import BuyersFilterContent from "./Buyers";
import ContractDatesFilterContent from "./ContractDates";
import ContractValueFilterContent from "./ContractValue";
import CPVCodeFilterContent from "./CPVCode";
import FrameworksFilterContent from "./Frameworks";
import { HiddenNoticesFilterGroup } from "./HiddenNotices";
import KeywordsFilterContent from "./Keywords";
import { NoticeListFilterGroup } from "./NoticeLists";
import ProcurementStageFilterContent from "./ProcurementStage";
import SignalsFilterContent from "./Signals";
import SignalScoreFilterContent from "./SignalScore";
import SuppliersFilterContent from "./Suppliers";

// Add new filters to this map
export const noticeFilterContents = {
  keywords: KeywordsFilterContent,
  signals: SignalsFilterContent,
  signalScore: SignalScoreFilterContent,
  procurementStage: ProcurementStageFilterContent,
  contractValue: ContractValueFilterContent,
  contractDates: ContractDatesFilterContent,
  buyers: BuyersFilterContent,
  suppliers: SuppliersFilterContent,
  frameworks: FrameworksFilterContent,
  cpvCode: CPVCodeFilterContent,
  noticeLists: NoticeListFilterGroup,
  hiddenNotices: HiddenNoticesFilterGroup,
};
